// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-lists-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  width: 100%;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 20px 0;
  width: 100%;
}

.template-tile {
  background-color: #212340;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
}

.template-content {
  color: white;
  margin-bottom: 15px;
}

.template-content h3 {
  display: flex;
  font-size: 1.2rem;
  font-weight: 500;
  justify-content: center;
  margin-bottom: 10px;
}

.template-locations {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  margin-top: 10px;
}

.location-tag {
  background-color: #e0e7ff;
  color: #4338ca;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.location-tag:hover {
  background-color: rgba(33, 150, 243, 0.25);
}

.templates-container table {
  width: 100%;
  border-collapse: collapse;
}

.templates-container th,
.templates-container td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.templates-container th {
  background-color: #f3f4f6;
  font-weight: 600;
}

.template-actions {
  display: flex;
  gap: 8px;
  padding: 10px;
  justify-content: flex-end;
  align-items: center;
}

.action-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  font-size: 1.1rem;
}

.use-icon {
  color: #10b981;
}

.use-icon:hover {
  color: #0e9f6e;
}

.edit-icon {
  color: #3b82f6;
}

.edit-icon:hover {
  color: #2563eb;
}

.delete-icon {
  color: #ef4444;
}

.delete-icon:hover {
  color: #d32f2f;
}

.action-icon:hover::after {
  content: attr(title);
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
}

.error-message {
  color: #ef4444;
  padding: 1rem;
  background-color: #fee2e2;
  border-radius: 0.375rem;
  margin: 1rem 0;
}

.loading {
  text-align: center;
  color: #94a3b8;
  padding: 2rem;
}

.task-item .completed {
  text-decoration: line-through;
  opacity: 0.7;
}

/* Pixel 9 and similar phone sizes */
@media screen and (max-width: 480px) {
  .tasklist-grid {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 15px;
  }

  .tasklist-tile {
    min-height: 80px;
    padding: 15px;
  }

  .tasklist-tile h3 {
    font-size: 1em;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #1a1a1a;
  padding: 24px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
}

.modal-content h2 {
  color: white;
  margin-bottom: 16px;
}

.modal-content p {
  color: #cccccc;
  margin-bottom: 24px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.modal-btn {
  min-width: 100px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-btn-cancel {
  background-color: #4a5568;
  color: white;
}

.modal-btn-delete {
  background-color: #dc2626;
  color: white;
}

.modal-btn:hover {
  opacity: 0.9;
}

.create-template-btn {
  background-color: #4CAF50;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
  display: inline-block;
}

.create-template-btn:hover {
  background-color: #45a049;
}

.create-template-btn:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/components/forms/MyLists.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".my-lists-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.page-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0;\n  width: 100%;\n}\n\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n  padding: 20px 0;\n  width: 100%;\n}\n\n.template-tile {\n  background-color: #212340;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 150px;\n}\n\n.template-content {\n  color: white;\n  margin-bottom: 15px;\n}\n\n.template-content h3 {\n  display: flex;\n  font-size: 1.2rem;\n  font-weight: 500;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.template-locations {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.location-tag {\n  background-color: #e0e7ff;\n  color: #4338ca;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.location-tag:hover {\n  background-color: rgba(33, 150, 243, 0.25);\n}\n\n.templates-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.templates-container th,\n.templates-container td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.templates-container th {\n  background-color: #f3f4f6;\n  font-weight: 600;\n}\n\n.template-actions {\n  display: flex;\n  gap: 8px;\n  padding: 10px;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.action-icon {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  font-size: 1.1rem;\n}\n\n.use-icon {\n  color: #10b981;\n}\n\n.use-icon:hover {\n  color: #0e9f6e;\n}\n\n.edit-icon {\n  color: #3b82f6;\n}\n\n.edit-icon:hover {\n  color: #2563eb;\n}\n\n.delete-icon {\n  color: #ef4444;\n}\n\n.delete-icon:hover {\n  color: #d32f2f;\n}\n\n.action-icon:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n}\n\n.error-message {\n  color: #ef4444;\n  padding: 1rem;\n  background-color: #fee2e2;\n  border-radius: 0.375rem;\n  margin: 1rem 0;\n}\n\n.loading {\n  text-align: center;\n  color: #94a3b8;\n  padding: 2rem;\n}\n\n.task-item .completed {\n  text-decoration: line-through;\n  opacity: 0.7;\n}\n\n/* Pixel 9 and similar phone sizes */\n@media screen and (max-width: 480px) {\n  .tasklist-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n    padding: 15px;\n  }\n\n  .tasklist-tile {\n    min-height: 80px;\n    padding: 15px;\n  }\n\n  .tasklist-tile h3 {\n    font-size: 1em;\n  }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: #1a1a1a;\n  padding: 24px;\n  border-radius: 8px;\n  max-width: 400px;\n  width: 90%;\n}\n\n.modal-content h2 {\n  color: white;\n  margin-bottom: 16px;\n}\n\n.modal-content p {\n  color: #cccccc;\n  margin-bottom: 24px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.modal-btn {\n  min-width: 100px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-btn-cancel {\n  background-color: #4a5568;\n  color: white;\n}\n\n.modal-btn-delete {\n  background-color: #dc2626;\n  color: white;\n}\n\n.modal-btn:hover {\n  opacity: 0.9;\n}\n\n.create-template-btn {\n  background-color: #4CAF50;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.create-template-btn:hover {\n  background-color: #45a049;\n}\n\n.create-template-btn:active {\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
